/* === BV Home — Hero parallax V1.3(支援 card scrolling:捲走 / 被覆蓋 雙模式 + ease) === */
(function(){
  'use strict';
  var SPEED_D = 0.5;  /* 桌機/平板 ≥768 視差速度 */
  var SPEED_M = 0.5;  /* 手機 <768 視差速度 */
  var EASE    = 0.12; /* 平滑係數:越小越滑、越慢跟上(建議 0.08–0.15) */

  function init(){
    var sec = document.querySelector('.template-index main > .shopify-section:first-child .banner-image');
    if(!sec || sec.hasAttribute('data-bvhh-init')) return;
    sec.setAttribute('data-bvhh-init','');
    var box = sec.querySelector('.banner-image__inner');
    var fig = sec.querySelector('.banner-image__image');
    if(!box || !fig) return;
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var wrap = sec.closest('.shopify-section');
    var next = wrap ? wrap.nextElementSibling : null;

    sec.classList.add('bvhh-parallax');
    var speed = 0, cur = 0, tgt = 0, running = false;

    function measure(){
      speed = window.innerWidth >= 768 ? SPEED_D : SPEED_M;
    }
    /* 模式 A:Hero 往上捲走的距離 → 圖片往下移,上緣空隙在視窗外 */
    function scrolled(r){
      return Math.max(0, -r.top);
    }
    /* 模式 B:下一個 section 蓋進 Hero 的距離 → 圖片往上移,下緣空隙被蓋住 */
    function covered(r){
      if(!next) return 0;
      var o = r.bottom - next.getBoundingClientRect().top;
      return Math.max(0, Math.min(o, r.height));
    }
    function compute(){
      var r = box.getBoundingClientRect();
      var up = scrolled(r), cov = covered(r);
      return { tgt:(up - cov) * speed, max:up, min:-cov };
    }
    function apply(){
      fig.style.transform = 'translate3d(0,' + cur.toFixed(2) + 'px,0)';
    }
    function loop(){
      var c = compute();
      tgt = c.tgt;
      cur += (tgt - cur) * EASE;
      if(cur > c.max) cur = c.max; /* 上緣空隙不得進入視窗 */
      if(cur < c.min) cur = c.min; /* 下緣空隙不得超出覆蓋範圍 */
      if(Math.abs(tgt - cur) < 0.05){ cur = tgt; running = false; }
      apply();
      if(running) requestAnimationFrame(loop);
    }
    function onScroll(){
      if(!running){ running = true; requestAnimationFrame(loop); }
    }

    measure();
    cur = tgt = compute().tgt;
    apply();
    window.addEventListener('scroll', onScroll, { passive:true });
    window.addEventListener('resize', function(){ measure(); onScroll(); });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();